<div class="title no-print" fxLayout="row" fxLayoutAlign="space-between end">
  <h1>{{'QRコード生成' | translate }}</h1>

  <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
    <mat-form-field [style.width.px]="250">
      <mat-select placeholder="{{'プリセット' | translate}}" (selectionChange)="changePreset($event)" [(value)]="qrSize">
        <mat-option *ngFor="let item of qrSizes" [value]="item[0]">
          {{ item[0] }}: {{ item[1] }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <form [formGroup]="qrFormGroup" fxLayoutGap="10px">
      <mat-form-field [style.width.px]="80">
        <input matInput placeholder="{{'QRサイズ' | translate }}" formControlName="settingQrSize" autocomplete="off"
          type="number">
      </mat-form-field>
      <mat-form-field [style.width.px]="80">
        <input matInput placeholder="{{'フォントサイズ' | translate }}" formControlName="settingFontSize" autocomplete="off"
          type="number">
      </mat-form-field>
    </form>

    <div class="basic-button" fxLayoutGap="10px">
      <button mat-raised-button (click)="changeSize()">
        <mat-icon>refresh</mat-icon>
      </button>
      <button mat-raised-button (click)="printClick()">
        <mat-icon>print</mat-icon>
      </button>
    </div>
  </div>
</div>

<div class="page" fxLayoutAlign="center start">

  <div class="result" [style.fontSize.px]="fontSize">
    <table>
      <ng-container *ngFor="let data of qrdata; let i = index">
        <ng-container *ngIf="qrSize < 300">
          <tr *ngIf="(i % 2) === 0">
            <td>
              <qrcode [qrdata]="data.siteUrl" [width]="qrSize" [errorCorrectionLevel]="'M'"></qrcode>
              {{ data.exhibitId }}<br>
              {{ data.name }}-<br>&nbsp;<br>&nbsp;
            </td>
            <ng-container *ngIf="qrdata.length === 1">
              <td [width]="qrSize">
                &nbsp;
              </td>
            </ng-container>
            <ng-container *ngIf="i < qrdata.length - 1">
              <td>
                <qrcode [qrdata]="qrdata[i+1].siteUrl" [width]="qrSize" [errorCorrectionLevel]="'M'"></qrcode>
                {{ qrdata[i+1].exhibitId }}<br>
                {{ qrdata[i+1].name }}<br>&nbsp;<br>&nbsp;
              </td>
            </ng-container>
          </tr>
        </ng-container>
        <ng-container *ngIf="qrSize >= 300">
          <tr>
            <td>
              <qrcode [qrdata]="data.siteUrl" [width]="qrSize" [errorCorrectionLevel]="'M'"></qrcode>
              {{ data.exhibitId }}<br>
              {{ data.name }}<br>&nbsp;<br>&nbsp;
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </table>
  </div>

</div>